<template>
	<section>
		<header class="qly-header">
			<div class="left">
				<i class="el-icon-s-fold" v-if="currentIsCollapse" @click="currentIsCollapse=!currentIsCollapse"></i>
				<i class="el-icon-s-unfold" v-else @click="currentIsCollapse=!currentIsCollapse"></i>
				<h1 class="title">小易时间管理后台管理系统</h1>
			</div>
			<div class="right">
				<div class="info">
					<el-dropdown @command="handleCommand">
						<span class="el-dropdown-link">
							<div class="info-tip">
								<div class="name">
									{{ userinfo.realName }}
								</div>
								<i class="el-icon-arrow-down el-icon--right"></i>
							</div>
						</span>
						<el-dropdown-menu slot="dropdown">
							<!-- <el-dropdown-item icon="el-icon-user-solid" command="my">我的主页</el-dropdown-item> -->
							<el-dropdown-item icon="el-icon-edit" command="updatePassword">修改密码</el-dropdown-item>
							<el-dropdown-item icon="el-icon-switch-button" command="out">退出登录</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<img class="picture" :src="avatarUrl" alt="">
				</div>
			</div>
		</header>

		<el-dialog title="修改密码" :visible.sync="passwordVisible" width="500px" :close-on-click-modal="false"
			:modal-append-to-body='false'>
			<div>
				<el-form ref="form" :model="operamForm" :rules="rules" label-width="120px" class="demo-ruleForm">
					<el-form-item label="原始密码:" prop="password">
						<el-input type="password" v-model="operamForm.password" placeholder="请输入原始密码"
							style="width: 200px;"></el-input>
					</el-form-item>
					<el-form-item label="新密码:" prop="newPassword">
						<el-input type="password" v-model="operamForm.newPassword" placeholder="请输入新密码"
							style="width: 200px;"></el-input>
					</el-form-item>
					<el-form-item label="确定密码:" prop="secpassword">
						<el-input type="password" v-model="operamForm.secpassword" placeholder="请输入确定密码"
							style="width: 200px;"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="passwordVisible = false">取 消</el-button>
				<el-button type="primary" @click="updatePassWord()">确 定</el-button>
			</span>
		</el-dialog>

	</section>
</template>
<script>
	export default {
		props: {
			isCollapse: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				avatarUrl: require("../../assets/images/avatar.jpeg"),
				passwordVisible: false, //显示修改密码弹窗
				operamForm: {
					password: "",
					newPassword: "",
					secpassword: ""
				},
				rules: {
					password: [{
						required: true,
						message: '请输入原始密码',
						trigger: 'blur'
					}],
					newPassword: [{
						required: true,
						message: '请输入原始密码',
						trigger: 'blur'
					}],
					secpassword: [{
						required: true,
						message: '请输入确定密码',
						trigger: 'blur'
					}],
				},
				currentIsCollapse: this.isCollapse,
			};
		},
		watch: {
			currentIsCollapse: {
				deep: true,
				immediate: true,
				handler() {
					this.$emit("input", this.currentIsCollapse);
				},
			}
		},
		computed: {
			userinfo() {
				return JSON.parse(localStorage.userInfo);
			},
		},
		methods: {

			handleCommand(command) {
				if (command == "my") {

				} else if (command == "updatePassword") {
					this.passwordVisible = true;
				} else if (command == "out") {
					this.logOut();
				}
			},

			updatePassWord() {
				this.$refs.form.validate((valid) => {
					if (valid) {
						if (this.operamForm.newPassword != this.operamForm.secpassword) {
							this.$message.warning("新密码和确认密码不一致");
							return
						}
						this.toUpdatePassWord();
					}
				});
			},

			//修改密码
			async toUpdatePassWord() {
				try {
					let parm = {
						uuid: this.userinfo.userId,
						param: this.operamForm.password,
						param1: this.operamForm.newPassword
					}
					const res = await this.$Request(this.$Interface.UpdatePassWord, parm);
					if (res.code == 1) {
						this.$message.success("修改密码成功");
						this.passwordVisible = false;
						setTimeout(() => {
							this.logOut();
						}, 2000)
					}
				} finally {
					this.loading = false;
				}
			},


			logOut() {
				localStorage.clear();
				this.$router.replace("/login");
			},
		},
	};
</script>
<style lang="scss">
	.qly-header {
		height: 60px;
		color: #fcfcfc;
		background-image: linear-gradient(-90deg, #2878ff, #51b0ff, #2878ff);
		display: flex;
		justify-content: space-between;
		align-items: center;
		box-sizing: border-box;

		.left {
			display: flex;
			flex-direction: row;
			margin-left: 20px;
			align-items: center;

			.logo {
				height: 40px;
			}

			.title {
				font-size: 20px;
				margin-left: 20px;
				font-family: cursive;
				font-weight: 700;
			}
		}

		.right {
			display: flex;
			justify-content: flex-end;
			align-items: center;
			margin-right: 20px;

			.info {
				display: flex;
				justify-content: center;
				align-items: center;

				.info-tip {
					display: flex;
					justify-content: center;
					align-items: center;
					margin-right: 20px;

					.name {
						color: #fff;
						margin-right: 10px;
					}
				}

				.picture {
					background: white;
					padding: 1px;
					border-radius: 50%;
					height: 35px;
					width: 35px;
					margin-right: 5px;
				}

			}







		}
	}
</style>